<div class="text-center cpopup login">
   <p>Please enter OTP we have sent on your mobile</p>
    <div class="mt-30">
        <ng-otp-input (onInputChange)="onMobileOtpChange($event)"  [config]="{length:6}" style="margin: auto;"></ng-otp-input> 
    </div>
    <div class="mt-30">        
        <button mat-stroked-button color="primary" class="f-18" (click)="goDashboard()" style="background-color: var(--grey2);">
            Proceed</button>
        <div class="mt-20 cPointer" *ngIf="resendotp">Resend OTP</div>
    </div> 
</div>